export const ALERT_EXT_TAG_GROUP_TABLE_LIMIT = 5;

export const DEFAULT_SORT_BY = 'createdAt';
export const ASC = 'ASC';
export const DESC = 'DESC';

export const MULTI = 'multi';
export const TAG_GROUP_NAME = 'tagGroupName';
export const TAG_NAME = 'tagName';
